export default __webpack_public_path__ + "static/media/img_5.d3f3c0d6.jpg";